'use strict';

export class Products {
  constructor() {
    this.name = 'products';
    console.log('%s module', this.name.toLowerCase());
    $('#ct-manual-list-21 .ct-item-grid__items .ct-item-grid__item').each(function(){
      var text_container = $(this).find(".ct-navigation-card__summary").text();
      var list = text_container.split("-");
      console.log(list);
      $(this).find(".ct-navigation-card__summary").empty();
        $(this).find(".ct-navigation-card__summary").append(`<h3>${list[0]}</h3><p>${list[1]}</p>`);
      })
  }
}
